export default __webpack_public_path__ + "static/media/wm-logo.d78026c0.jpg";